export default __webpack_public_path__ + "static/elotitos-3bb3acde00cef0e125cb164231b1996b.png";